// extracted by mini-css-extract-plugin
module.exports = {"MainContentContainer":"MainContentContainer_MainContentContainer__2V3K7"};